module.exports = __webpack_public_path__ + "static/media/dk_2N.93b6d141.png";